export default {
  // 联系我们
  GET_LIST: '/jcnapi/contact/getInfo',
  DEL: '/jcnapi/contact/addr/delete',
  //保存
  SAVE: '/jcnapi/contact/addr/save',
  GET: '/jcnapi/contact/getInfo',
  SET_BANNER: '/jcnapi/contact/setBanner',
  SET_CONTACT: '/jcnapi/contact/setContact'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/contact/index.js